let operation = null

const setOperation = (data) => {
    operation = data;
}

const getOperation = () => {
    return operation
}

export {
    setOperation,
    getOperation
}